var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseVideosCount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.25C7.5 10.6642 7.16421 11 6.75 11C6.33579 11 6 10.6642 6 10.25C6 9.83579 6.33579 9.5 6.75 9.5C7.16421 9.5 7.5 9.83579 7.5 10.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.25C14 10.6642 13.6642 11 13.25 11C12.8358 11 12.5 10.6642 12.5 10.25C12.5 9.83579 12.8358 9.5 13.25 9.5C13.6642 9.5 14 9.83579 14 10.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7L14 7C14 4.79086 12.2091 3 10 3C7.79086 3 6 4.79086 6 7L5 7C3.89543 7 3 7.89543 3 9V14C3 16.2091 4.79086 18 7 18H13C15.2091 18 17 16.2091 17 14V9C17 7.89543 16.1046 7 15 7ZM10 4.5C11.3807 4.5 12.5 5.61929 12.5 7L7.5 7C7.5 5.61929 8.61929 4.5 10 4.5ZM5 8.5C4.72386 8.5 4.5 8.72386 4.5 9V14C4.5 15.3807 5.61929 16.5 7 16.5H13C14.3807 16.5 15.5 15.3807 15.5 14V9C15.5 8.72386 15.2761 8.5 15 8.5H5Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseVideosCount);
export default __webpack_public_path__ + "static/media/course_videos_count.76db7cae724bea4e546a775945fd2d6d.svg";
export { ForwardRef as ReactComponent };